import Input from '../../../components/Input/Input';
import ErrorText from '../../../components/ErrorText';
import { useState } from 'react';
import { useLoginWithEmail } from '@privy-io/react-auth';
import OtpInput from 'react-otp-input';

const CodeInput = () => {
  const { loginWithCode } = useLoginWithEmail();
  const [code, setCode] = useState('');
  const [authError, setAuthError] = useState<string>('');

  const handleOtp = async (value: string) => {
    try {
      setCode(value);
      setAuthError('');

      if (value && value.length === 6) {
        await loginWithCode({ code: value });
      }
    } catch (error) {
      console.log(error);
      setAuthError('Invalid Code');
    }
  };

  return (
    <div className="flex w-full flex-col gap-1">
      <OtpInput
        value={code}
        containerStyle={{ flex: 1, gap: '0.5em' }}
        onChange={handleOtp}
        numInputs={6}
        renderInput={(props) => (
          <Input {...props} type="text" className="!h-14 !w-full !px-0 text-lg" fullWidth={true} />
        )}
      />

      {authError && <ErrorText>{authError}</ErrorText>}
    </div>
  );
};

export default CodeInput;
